import { IMessagesState } from "../reducers/messagesReducer";

export const selectMessagesQueue = ({ messages }: IMessagesState) => messages;
